import { render, staticRenderFns } from "./touristList.vue?vue&type=template&id=6dbcaca0&scoped=true"
import script from "./touristList.vue?vue&type=script&lang=js"
export * from "./touristList.vue?vue&type=script&lang=js"
import style0 from "./touristList.vue?vue&type=style&index=0&id=6dbcaca0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbcaca0",
  null
  
)

export default component.exports